
<div class="row">
  <div class="col-12 col-lg-7 text-center">
    <h3 class="title" *ngIf="giPantMode">{{'DOWNLOAD.GIPANT.TITLE' | translate}}</h3>
    <h3 class="title" *ngIf="henterPantMode">{{'DOWNLOAD.HENTERPANT.TITLE' | translate}}</h3>
    <div class="description">
      <p *ngIf="giPantMode">
        {{'DOWNLOAD.GIPANT.DESCRIPTION' | translate}}
      </p>
      <p *ngIf="henterPantMode">
        {{'DOWNLOAD.HENTERPANT.DESCRIPTION' | translate}}
      </p>
    </div>
    <div class="buttons-wrap">
      <a [href]="appleStoreLink" class="store-btn apple" target="_blank"></a>
      <a [href]="googlePlayLink" class="store-btn android" target="_blank"></a>
    </div>
  </div>
  <div class="col-12 col-lg-5">
    <div class="img-wrap">
      <img *ngIf="giPantMode" ngSrc="../../../assets/images/gp-download-app.png" width="500" height="398" loading="lazy">
      <img *ngIf="henterPantMode" ngSrc="../../../assets/images/henterpant-download-app.png" width="490" height="398" loading="lazy">
    </div>
  </div>
</div>
